import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { GENERAL_STORE } from 'store'
import { DialogPopup } from './DialogPopup'
import { DialogPopupHandlerProps } from './DialogPopup.types'

const DialogPopupHandlerComponent = (props: DialogPopupHandlerProps) => {
  const {
    [GENERAL_STORE]: {
      dialogPopupProps
    }
  } = props

  if (!dialogPopupProps) return null

  return (
    <DialogPopup {...dialogPopupProps} />
  )
}

const DialogPopupHandler = inject(
  GENERAL_STORE
)(observer(DialogPopupHandlerComponent))
export { DialogPopupHandler }
